'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPageStatus = setPageStatus;
var PAGE_STATUS = exports.PAGE_STATUS = 'PAGE_STATUS';

function setPageStatus(status, error) {
  return {
    type: PAGE_STATUS,
    status: status,
    error: error
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/ServerSide/actions.js
// module id = 245
// module chunks = 0